<template>
  <div class="gubaTab-container tabs-list" style="min-height: 100vh;margin-bottom: 110px">
    <div class="item-box">
      <template v-for="(item, $index) in tabs[tabIndex].list">
        <div :key="$index" class="tab-item" @click="goDetail(item)">
          <div class="user-info-box">
            <img :src="item.image" alt="">
            <p class="tab-title">{{item.nickName}}</p>
          </div>
          <p class="wrap-line">{{item.title}}</p>
          <div class="tab-label">
            <span>{{item.createTime | showtime}}</span>
            <div class="icon-box">
              <span @click.stop="supportDetailApi(item, $index)"><i :class="{disable: item.isSupport === 0}" class="icon-awesome"></i>{{item.supportCount}}</span>
              <span @click="goDetail(item)"><i class="icon-view"></i>{{item.reviewCount}}</span>
            </div>
            <!-- <span v-if="item.formatdate">{{item.formatdate}}</span> -->
          </div>
        </div>
        <div v-if="$index==3 && ad" class="tab-item" :key="item.id">
          <Ad width="3.45rem" height="0.6rem" :content="ad" />
        </div>
      </template>
    </div>
    <infinite-loading ref="gubainf" @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
      <div slot="no-more">无更多数据</div>
      <div v-if="tabs[tabIndex].list.length === 0" slot="no-results" class="no-results">
      </div>
      <div v-else slot="no-results">
      </div>
      <div slot="spinner" class="tab-spinner">正在加载...</div>
    </infinite-loading>
    <div class="guba-footer-box" :style="{display: showFooter ? 'flex' : 'none'}">
      <div class="user-login-box" v-if="userInfo.token">
        <div class="user-info-box">
          <img :src="userInfo.headImage" alt="">
          <span>{{userInfo.nickname}}</span>
        </div>
        <div class="send-info-box">
          <span class="text-btn" @click="loginOut">退出登录</span>
          <div class="send-btn" @click="goSend">发布新帖<i class="icon-send"></i></div>
        </div>
      </div>
      <p v-else>欢迎来到富利港美股股圈，请 <span @click="goLogin" class="text-btn">登录/注册</span>后发表新帖</p>
    </div>
    <Toast v-if="showToast" :text="toastText"></Toast>
  </div>
</template>

<script type="text/ecmascript-6">
import moment from 'moment'
import Toast from '@/components/toast.vue'
import InfiniteLoading from 'vue-infinite-loading'
import { request } from '@/api/request'
import { support, unSupport } from '@/api'
import { mapState } from 'vuex'
import Ad from '../../advertisement/index.vue'

export default {
  components: { InfiniteLoading, Toast, Ad },
  data () {
    return {
      showToast: false,
      toastText: '',
      showFooter: true,
    }
  },
  computed: {
    ...mapState({
      code: state => state.code,
      symbol: state => state.symbol,
      market: state => state.market,
      tabs: state => state.common.tabs,
      tabIndex: state => state.common.tabIndex,
      userInfo: state => state.userInfo,
      ad: state => state.homeAdList.pop()
    })
  },
  filters: {
    showtime(_date) {
      let day = moment(new Date())
      let date = moment(_date)
      if (day.year() === date.year()) {
        return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
      } else {
        return `${date.year()}-${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
      }
    },
  },
  activated() {
    this.$refs.gubainf.stateChanger.reset()
  },
  methods: {
    async infiniteHandler($state) {
      let canload = await this.getListData()
      if (canload) $state.loaded()
      else $state.complete()
    },
    async supportDetailApi (item, index) {
      if (!this.userInfo.token) {
        this._toast('请登录')
        return
      }
      const { newsId, isSupport } = item
      const params = {
        token: this.userInfo.token,
        serverId: this.userInfo.serverId,
        newsId: newsId
      }
      let res = isSupport === 0 ? await support(params) : await unSupport(params)
      if (res.code === 1) {
        if (item.isSupport === 0) {
          this.tabs[this.tabIndex].list[index].isSupport = 1 
          this.tabs[this.tabIndex].list[index].supportCount += 1
        } else {
          this.tabs[this.tabIndex].list[index].isSupport = 0
          this.tabs[this.tabIndex].list[index].supportCount -= 1
        }
      }
    },
    async getListData() {
      if (this.tabs[this.tabIndex].pageNo === 0) this.tabs[this.tabIndex].pageNo++
      const params = {
        token: this.userInfo.token,
        appCode: '9fztgw',
        symbol: this.code.toString().toLowerCase(),
        market: this.market === 'HKIDX' ? 'HKSE' : this.market.toLowerCase(),
        pageNo: this.tabs[this.tabIndex].pageNo,
        pageSize: 20
      }
      let res = await request.get({url: request.apis.stockBar.list, params})
      const { code, data } = res
      if (code === 1) {
        this.tabs[this.tabIndex].list = this.tabs[this.tabIndex].list.concat(data)
        if (data.length > 0) {
          this.tabs[this.tabIndex].pageNo += 1
          return true
        }
      }
      else return false
    },
    _toast (toastText, time = 3000) {
      this.toastText = toastText
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
      }, time)
    },
    goLogin() {
      this.tabs[this.tabIndex].pageNo = 1
      this.tabs[this.tabIndex].list = []
      this.$router.push(`/login.html`)
    },
    goDetail(item) {
      // if(!this.userInfo.token) return
      let newsId = item.newsId
      this.$router.push(`/viewDetail/${this.market}/${this.symbol}/${newsId}.html`)
    },
    goSend() {
      this.$router.push(`/send/${this.market}/${this.symbol}/send.html`)
    },
    loginOut () {
      const userInfo = {
        token: '',
        headImage: '',
        serverId: '',
        nickname: '',
        username: ''
      }
      this.tabs[this.tabIndex].pageNo = 1
      this.tabs[this.tabIndex].list = []
      this.$refs.gubainf.stateChanger.reset()
      this.$store.commit('setUserInfo', userInfo)
    },
    handleScroll() {
      if(!document.getElementById('tabs')) return
      let h = document.documentElement.clientHeight
      let btm = document.getElementById('tabs').getBoundingClientRect().bottom
      this.showFooter = !((h - btm) <=  132)
      console.log(111, this.showFooter, h, btm)
    }
  },
  mounted() {
    this.handerBindthis = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.handerBindthis)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handerBindthis)
  }
}
</script>
<style lang="stylus" scoped>
.wrap-line
  word-wrap break-word
  word-break normal
.icon-box
  display inline-flex
  justify-content space-between
  width 90px
  i
    margin-right 2px
    cursor pointer
  span
    display inline-flex
    align-items center
    line-height 20px

.user-info-box
  display flex
  align-items center
  margin-bottom 4px
  img
    width 30px
    height 30px
    border-radius 50%
    margin-right 8px
  span
    width 0
    flex 1
    overflow hidden
    white-space nowrap
    text-overflow ellipsis

.guba-footer-box
  display flex
  justify-content center
  align-items center
  position fixed
  left 0
  bottom 75px
  z-index 999
  width 100%
  height 57px
  background-color #FFFFFF
  border-top:  0.01rem solid #f5f5f5

.user-login-box
  width 100%
  padding 0 12px
  display flex
  align-items center
  justify-content space-between
  .user-info-box
    width 0
    flex 1
  .send-info-box
    display flex
    align-items center


.icon-send
  width 16px
  height 14px
  margin-left 2px
  background-image url('../../../assets/icon-send.png')
  background-size: 100% 100%
  background-repeat no-repeat
  color #ffffff
  align-items center


.icon-view
  display inline-block
  width 15px
  height 14px
  background-image url('../../../assets/icon-view.png')
  background-repeat no-repeat
  background-size: 100% 100%


.icon-awesome
  display inline-block
  width 15px
  height 14px
  background-image url('../../../assets/icon-awesome.png')
  background-repeat no-repeat
  background-size 100% 100%
  &.disable
    background-image url('../../../assets/icon-awesome-gray.png')

.text-btn
  color #409AFB
  text-decoration underline

.send-btn
  display flex
  width 140px
  height 36px
  justify-content center
  background #F43737
  border-radius 2px
  margin-left 12px
  align-items center
  color #fff

.footer-box
  display flex
  justify-content space-between
  padding 0 12px

.tabs-list
  display flex
  flex-flow column
  .no-results
    background url('../../../assets/no_data.png')
    height 200px
    width 200px
    background-size cover
    margin 50px auto
  .tab-spinner
    font-size 13px
    padding 15px 0 30px 0
    color: #999
  .item-box
    .tab-item:last-child
      margin-bottom 10px
  .tab-item
    padding 10px 8px
    border-bottom 1px solid #f5f5f5
    .tab-title
      font-size 15px
      color #333
      // height 22px
      line-height 21px
      font-weight 400
      overflow:hidden; 
      text-overflow:ellipsis;
      display:-webkit-box; 
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2; 
    .tab-label
      display flex
      justify-content space-between
      font-size 12px
      color #999
      margin-top 5px
</style>